/* eslint-disable better-mutation/no-mutation */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { loadMemberServerStorageData } from 'tradera/state/member-storage/actions';

export type MemberStorageState = {
    isUnitialized: boolean;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    data: Record<string, string>;
};

const initialState: MemberStorageState = {
    isUnitialized: true,
    isLoading: false,
    isError: false,
    isSuccess: false,
    data: {}
};

const memberStorageSlice = createSlice({
    name: 'memberStorage',
    initialState,
    reducers: {
        setData: (state, action: PayloadAction<Record<string, string>>) => {
            state.isUnitialized = false;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            state.data = action.payload;
        },
        setValue: (
            state,
            action: PayloadAction<{ key: string; value: string }>
        ) => {
            state.data[action.payload.key] = action.payload.value;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(loadMemberServerStorageData.pending, (state) => {
            state.isUnitialized = false;
            state.isLoading = true;
            state.isError = false;
            state.isSuccess = false;
        });
        builder.addCase(
            loadMemberServerStorageData.fulfilled,
            (state, action) => {
                state.isUnitialized = false;
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                action.payload.rows?.forEach((row) => {
                    if (row.key && row.value) {
                        state.data[row.key] = row.value;
                    }
                });
            }
        );
        builder.addCase(loadMemberServerStorageData.rejected, (state) => {
            state.isUnitialized = false;
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
        });
    }
});

export const { setData, setValue } = memberStorageSlice.actions;

export default memberStorageSlice.reducer;
